import { render, staticRenderFns } from "./SModalRight.vue?vue&type=template&id=5f453fe2&scoped=true"
import script from "./sModalRight.ts?vue&type=script&lang=ts&external"
export * from "./sModalRight.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalRight.vue?vue&type=style&index=0&id=5f453fe2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f453fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f453fe2')) {
      api.createRecord('5f453fe2', component.options)
    } else {
      api.reload('5f453fe2', component.options)
    }
    module.hot.accept("./SModalRight.vue?vue&type=template&id=5f453fe2&scoped=true", function () {
      api.rerender('5f453fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-modal-right/SModalRight.vue"
export default component.exports